(function () {
  // Mobile only: the real size-selector element (<variant-selects>)
  // and the Add to Bag form both start out inside .product__buybox —
  // this moves those same elements (not a second render of either;
  // Dawn generates the size picker's option input ids/names from
  // section.id alone, so rendering it twice on one page would
  // produce duplicate ids) into the normal page flow: size picker
  // right after the price row (title and price share one line above
  // it), then the Add to Bag form right after that. The form stays
  // there permanently — mobile-atc-bottom-sticky.js only toggles its
  // CSS position between normal flow and fixed, it never moves the
  // element itself. Desktop is untouched: matchMedia below moves
  // both straight back into the buybox if the viewport grows past
  // the mobile breakpoint.
  var mql = window.matchMedia('(max-width: 749px)');

  function relocate(el, anchorEl, homeParent) {
    if (!el.dataset.homeCaptured) {
      el.dataset.homeCaptured = 'true';
      el._homeParent = homeParent;
      el._homeNextSibling = el.nextElementSibling;
    }

    if (mql.matches) {
      if (anchorEl.nextElementSibling !== el) {
        anchorEl.insertAdjacentElement('afterend', el);
      }
    } else if (el.parentElement !== el._homeParent) {
      if (el._homeNextSibling) {
        el._homeParent.insertBefore(el, el._homeNextSibling);
      } else {
        el._homeParent.appendChild(el);
      }
    }
  }

  function setupProduct(productInfo) {
    var variantSelects = productInfo.querySelector('[id^="variant-selects-"]');
    var buybox = productInfo.querySelector('.product__buybox');
    var priceRow = productInfo.querySelector('.product__info-container [id^="price-"]');
    var productForm = productInfo.querySelector('product-form.product-form');
    if (!variantSelects || !buybox || !priceRow) return;

    relocate(variantSelects, priceRow, buybox);

    if (productForm) {
      relocate(productForm, variantSelects, buybox);
    }
  }

  function init() {
    var products = document.querySelectorAll('product-info');
    products.forEach(setupProduct);
    mql.addEventListener('change', function () {
      products.forEach(setupProduct);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
